import { GripVertical } from "lucide-react";
import React from "react";

export const SECTION_DRAG_TYPE = "application/x-dashboard-section";

export const SectionDragHandle = ({
	id,
	label,
	onDragStart,
	onDragEnd,
	className = "",
	interactive = true,
}) => {
	const baseClass = `inline-flex h-7 w-7 shrink-0 cursor-grab items-center justify-center rounded text-[var(--color-text-tertiary)] transition-colors active:cursor-grabbing ${className}`;

	if (!interactive) {
		return (
			<span aria-hidden="true" className={baseClass}>
				<GripVertical className="h-4 w-4" />
			</span>
		);
	}

	return (
		<button
			type="button"
			draggable
			onClick={(event) => event.stopPropagation()}
			onDragStart={(event) => {
				event.stopPropagation();
				event.dataTransfer.effectAllowed = "move";
				event.dataTransfer.setData(SECTION_DRAG_TYPE, id);
				event.dataTransfer.setData("text/plain", `section:${id}`);
				onDragStart?.(id);
			}}
			onDragEnd={(event) => {
				event.stopPropagation();
				onDragEnd?.();
			}}
			aria-label={`Drag to reorder ${label}`}
			title="Drag to reorder"
			className={`${baseClass} hover:bg-[var(--color-bg-secondary)] hover:text-[var(--color-text-primary)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)]`}
		>
			<GripVertical className="h-4 w-4" />
		</button>
	);
};

export default SectionDragHandle;
